import styled from '@emotion/native';
import { useTheme } from '@emotion/react';
import { Row } from 'components/base';
import { Text } from 'design-system/base';
import { BASE_SIZE, FONT_FAMILY, PADDING } from 'design-system/theme';
import { MD3DarkTheme as DateDarkTheme, MD3LightTheme as DateLightTheme } from 'react-native-paper';
import { TimePickerModal, DatePickerInput } from 'react-native-paper-dates';

export const StyledDatePickerInput = styled(DatePickerInput)(({ theme }) => ({
  backgroundColor: theme.color['transparent'],
  fontFamily: FONT_FAMILY['regular'],
}));

export const StyledTimePickerInput = styled(TimePickerModal)(({ theme }) => ({
  backgroundColor: theme.color['transparent'],
  fontFamily: FONT_FAMILY['regular'],
}));

export const TextWrapper = styled(Row)(({ theme }) => ({
  paddingVertical: PADDING['2xs'],
  paddingHorizontal: PADDING.xs,
  flex: 1,
  justifyContent: 'center',
  borderBottomColor: theme.color['underline'],
  borderBottomWidth: BASE_SIZE[1],
}));

export const StyledText = styled(Text)({
  fontSize: PADDING['s'],
  top: PADDING['xs'],
  fontFamily: FONT_FAMILY.regular,
});

export const useCustomStyles = () => {
  const theme = useTheme();

  const isDarkTheme = theme.name === 'dark';

  let paperTheme = isDarkTheme ? DateDarkTheme : DateLightTheme;

  paperTheme = {
    ...paperTheme,
    colors: {
      ...paperTheme.colors,
      primary: theme.color['primary'],
      onSurfaceVariant: theme.color['text-default'],
      primaryContainer: theme.color['input-color'],
      secondaryContainer: theme.color['input-color'],
      elevation: {
        ...paperTheme.colors.elevation,
        level3: theme.color['base-grey'],
      },
    },
    fonts: {
      ...paperTheme.fonts,
      default: {
        ...paperTheme.fonts.default,
        fontFamily: FONT_FAMILY.regular,
      },
    },
  };

  return { paperTheme, theme };
};
